import { render, staticRenderFns } from "./craftsman_home.vue?vue&type=template&id=37f86e2e"
import script from "./craftsman_home.vue?vue&type=script&lang=js"
export * from "./craftsman_home.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports